import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HandlerService {
  constructor(public toast: ToastService,
    public router: Router) { }
    
    i=0;
    j=0;
    check:boolean=false;
 user;
 header:boolean;
 regionId;
 stateId;
 cityId;
 street;
 zipcode;
 doorNbr;
 flatName;
 flatNo;
 custName;
 lat;
 lon;
 buttonObj:any=[{name:"Individual House",flat:false,id:1},
 {name:"Flat",flat:true,id:2}]
 flatType = this.buttonObj[0].id;
 appt:boolean = this.buttonObj[0].flat;
 amount;
 payObj:any;
 loader:boolean=false;
 contactNbrMob;
 previousUrl;
 deny = 0 ;
 off =0;
 err(err: any) {
  if (err.error) {
      let error: any = err.error;
      this.toast.open(error.msg, 'err');
  }
  if (err.status == 401)
      this.fourNotOne();
  if (err.status == 500)
      this.toast.open("Internal Server Error", 'err');
  if (err.status == 0)
      this.toast.open("Unable to reach Server", 'err');
}

staticError(err: any){
  this.toast.openPay(err, 'err')
}

phNumError(err: any){
  this.toast.open(err, 'err')
}

error(err: any) {
  this.toast.open(err, 'err');
}
fourNotOne() {
  this.toast.open("Session Expired", 'err');
  // localStorage.clear();
  // sessionStorage.clear();
  this.user = undefined;
  this.router.navigate(['/login']);
}
res(msg) {
  this.toast.open(msg, 'res');
}

loginRes(res) {
  localStorage.setItem('currentUserId', res.userId);
  localStorage.setItem('organizationId', res.organizationId);
}


validateRes(res) {
  localStorage.setItem('hashKey', res.hashKey);
}

loginVendorRes(res){
  localStorage.setItem('currentUserId', res.userId);
  localStorage.setItem('organizationId', res.organizationId); 
  localStorage.setItem('hashKey', res.hashKey);
}


}
